import React from 'react';
import Posts from '../posts/Posts';
import './Blogs.css'


const Blogs = () => {
  return (
    <div className="blogs ">
      <Posts />
    </div>
  );
};

export default Blogs;
